import format from 'date-fns/format';

export default {
  async fetchCollection(ref){
    const docs = [];
    const querySnapshot = await ref.get();
    querySnapshot.forEach(docObj =>{
      docs.push({ ...docObj.data(), id: docObj.id });
    });
    return docs;
  },
  async fetchDocument(ref){
    const doc = await ref.get();
    return { ...doc.data(), id: doc.id };
  },
  async create(ref, value){
    const now = format(new Date(), 'YYYY-MM-DD HH:mm:ss');
    value.createdAt = now;
    value.updatedAt = now;
    const doc = await ref.add({ ...value });
    return { id: doc.id, ...value };
  },
  async update(ref, value){
    value.updatedAt = format(new Date(), 'YYYY-MM-DD HH:mm:ss');
    await ref.set({ ...value }, { merge: true });
    return true;
  },
  async remove(ref){
    await ref.delete();
    return true;
  },
  async addToArray({ ref, key, value }){
    await ref.update({
      [key]: this.firestoreRef.FieldValue.arrayUnion(value),
      updatedAt: format(new Date(), 'YYYY-MM-DD HH:mm:ss')
    });
    return true;
  },

  async removeFromArray({ ref, key, value }){
    await ref.update({
      [key]: this.firestoreRef.FieldValue.arrayRemove(value),
      updatedAt: format(new Date(), 'YYYY-MM-DD HH:mm:ss')
    });
    return true;
  },
  async updateArrayElem({ ref, key, beforeVal, afterVal }){
    const payload = {
      ref,
      key
    };
    await Promise.all([
      this.removeFromArray({ ...payload, value: beforeVal }),
      this.addToArray({ ...payload, value: afterVal })
    ]);
    return true;
  }
};
